// store.js
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/index.js';
import { rootReducer } from './root.reducer.js';
import { rootSaga } from './root.saga.js';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [], // add reducers you want to persist
};

// Wrap root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with Redux Toolkit
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false, // Disable thunk since we're using saga
      serializableCheck: false, // Needed for redux-persist
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Create persistor
export const persistor = persistStore(store);

// Run saga
sagaMiddleware.run(rootSaga);
